import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal, effect, HostBinding } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { IamActionValues } from 'src/app/models/permission';
import { TranslationPipe } from 'src/app/pipes/translation/translation-pipe';
import { PermissionService } from 'src/app/services/user/permission-service';

export type ButtonType = 'primary' | 'secondary' | 'danger';

@Component({
  selector: 'app-button',
  imports: [CommonModule, ButtonModule, TranslationPipe],
  templateUrl: './app-button.html',
  styleUrl: './app-button.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppButton {
  @HostBinding('style.display')
  get hostDisplay(): string {
    return this.allowed() ? '' : 'none';
  }

  permissionService = inject(PermissionService);
  route = inject(ActivatedRoute);

  allowed = signal(false);

  type = input<ButtonType>('primary');
  label = input<string>('');

  /** Show icon */
  showIcon = input<boolean>(false);
  iconPosition = input<'before' | 'after'>('after');

  /** Icon class */
  iconClass = input<string>('');
  extraClasses = input<string>('');
  clicked = output<void>();
  disable = input<boolean>(false);

  /** Show spinner */
  showSpinner = input<boolean>(false);

  private typeClassMap: Record<ButtonType, string> = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    danger: 'btn-danger'
  };

  // allowed: boolean = false;
  // moduleCode = input<string | null>(null);
  moduleCode: string | null = null;
  bypassPermCheck = input<boolean>(false); //for dialogs

  className = computed(() => {
    const baseClass = this.typeClassMap[this.type()];
    return `${baseClass} ${this.extraClasses()}`.trim();
  });

  constructor() {
    effect(() => {
      const label = this.label();

      if (!this.bypassPermCheck()) this.checkPermission();
      else this.allowed.set(true);
    })
  }

  handleClick() {
    this.clicked.emit();
  }

  ngOnInit() {
    this.moduleCode = this.route.snapshot.data['moduleCode'];
  }

  ngOnChanges() { }

  async checkPermission() {
    if (!this.moduleCode) {
      this.allowed.set(true);
      return;
    }

    const required = this.permissionService.getTypeOfPermissionBasedOnLabel(this.label().toLowerCase());
    if (required)
      this.allowed.set(await this.permissionService.hasPermission(this.moduleCode, required));
    else {
      this.allowed.set(true);
    }
  }
}
